import React from 'react'
// import { pt } from 'common-data/proptypehelpers'
import Tooltip from 'rc-tooltip'
import _ from 'common-tools/LodashHelper'

export class ToolTip extends React.Component {
  // static pt = {
  //   color: pt.string,
  //   toolTip: pt.string,
  //   placement: pt.string,
  //   overlayClassName: pt.string,
  //   htmlToolTip: pt.bool
  // }

  static defaultProps = {
    placement: 'top',
    htmlToolTip: false
  }

  render () {
    const { children, color, toolTip, placement, overlayClassName, htmlToolTip } = this.props

    const toolTipColor = _.replace(color, 'outline-', '')
    return (
      <Tooltip placement={placement}
        overlayClassName={`${overlayClassName || ''} ${toolTipColor || ''}`} mouseEnterDelay={1}
        overlay={htmlToolTip ? <span dangerouslySetInnerHTML={{ __html: toolTip }}></span> : toolTip}>
        {children}
      </Tooltip>
    )
  }
}
